import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { FormControl, FormGroup, FormControlLabel, RadioGroup, Radio } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1)
  },
  formLabel: {
    marginBottom: theme.spacing(2)
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}));

const SpecialSituation = ({ animalinfo, specialsituations, handleSpecialSituations }) => {
  const classes = useStyles();

  const data = useStaticQuery(graphql`
    query specialCaseLabelsQuery {
      specialCaseLabels: sanitySpecialCaseLabels {
        crampLabel
        foreignObjectLabel
        intoxicationLabel
        noneLabel
        stomachLabel
        accidentLabel
      }
    }
  `);

const specialCaseLabelsData = (data || {}).specialCaseLabels;

  return (
    <>
      <div className="formStep--wrapper">
        <h2>Besondere Situationen</h2>

        <div className="generalCondition--grid">
          <FormControl component="fieldset" className={`${classes.formControl} specialSituations`}>
            <RadioGroup
              aria-label="specialSituations"
              name="specialSituations"
              value={specialsituations}
              onChange={handleSpecialSituations}
            >
              <FormControlLabel
                className={classes.formLabel}
                value="none"
                control={<Radio />}
                label={specialCaseLabelsData.noneLabel}
              />
              <FormControlLabel
                className={classes.formLabel}
                value="trauma"
                control={<Radio />}
                label={specialCaseLabelsData.accidentLabel}
              />

              <FormControlLabel
                className={classes.formLabel}
                value="cramp"
                control={<Radio />}
                label={specialCaseLabelsData.crampLabel}
              />

              <FormControlLabel
                className={classes.formLabel}
                value="foreign"
                control={<Radio />}
                label={specialCaseLabelsData.foreignObjectLabel}
              />
              <FormControlLabel
                className={classes.formLabel}
                value="poison"
                control={<Radio />}
                label={specialCaseLabelsData.intoxicationLabel}
              />
              {animalinfo.species === "dog" && animalinfo.weight > 18 ? (
                <FormControlLabel
                  className={classes.formLabel}
                  value="stomach"
                  control={<Radio />}
                  label={specialCaseLabelsData.stomachLabel}
                />
              ) : null}
            </RadioGroup>

            <FormGroup />
          </FormControl>
        </div>
      </div>
    </>
  );
};

export default SpecialSituation;
